import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {Product} from "../product";
import {Website} from "../website";
import {Permissions} from "../../../user/permissions";
import {ChangelogComponent} from "../changelog/changelog.component";
import {ExtensionsComponent} from "../extensions/extensions.component";
import {IDropdownListItem} from "../../../shared/components/dropdown-list/dropdown-list-item";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {FilterProductByChildrenProductPipe} from "../filter-product-by-children.pipe";
import {ConfirmDialogComponent} from '../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import {TextUtils} from '../../../shared/utils/text-utils';
import {ProductService} from '../product.service';
import {SortProductsByParentProductPipe} from "../sort-products-by-parent-product.pipe";
import {PageLoadingBarService} from "../../../shared/services/page-loading-bar/page-loading-bar.service";
import {PremiumPluginDialogComponent} from "../premium-plugin-dialog/premium-plugin-dialog.component";

import {ActivatedRoute, Router} from '@angular/router';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {DbStoreState} from "../../../store/reducers";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {ActivityAction, ActivityStatus, IActivity} from "../../../activities/activity";
import {ProductActionService} from "../product-action.service";
import {Observable} from "rxjs";
import {Config} from "../../../config/config";
import {ThirdPartyThemeActivationDialogComponent} from "../themes/third-party-theme-activation-dialog/third-party-theme-activation-dialog.component";
import {BuilderTemplates} from "../builder-templates/builder-templates";
import {MultisiteActionConfirmDialogComponent} from "../../../shared/components/dialogs/mulitiste-action-confirm-dialog/multisite-action-confirm-dialog.component";
import {map, filter, first, switchMap} from "rxjs/operators";


@Component({
    selector: 'db-product-item',
    templateUrl: './product-item.component.html',
    styleUrls: ['./product-item.component.scss'],
    standalone: false
})
export class ProductItemComponent implements OnInit {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;
  public config = Config;

  @Input() website: Website;
  @Input() product: Product;
  @Input() allProducts: Product[];
  @Input() scope: string;
  @Input() activeTab: string;
  @Input() userPermissions: Permissions;

  @ViewChild('logo') logoRef: ElementRef;

  @Output() toggled: EventEmitter<void>;

  public parentPlugin: Product;
  public isManagable: boolean;
  public isPublishedSinglePlugin: boolean;
  public productDesc: string;
  public lastTemplateItem: any;
  public activeTheme: any;
  public builderPlugin: any;
  public items: IDropdownListItem[];
  public InactiveItems: IDropdownListItem[];
  public UpdateItems: IDropdownListItem[];
  public ActiveItems: IDropdownListItem[];
  public companyName: string = 'Dashboard';

  private _userSubscriptions: UserSubscription[];
  public currentSubscription: UserSubscription;
  public UserSubscriptionType: any = UserSubscriptionType;

  public ongoingActivity$: Observable<IActivity>;
  public ongoingActivityStatusClass$: Observable<string>;

  constructor(
    private _element: ElementRef,
    private _router: Router,
    private _store: Store<DbStoreState>,
    private _dialogService: DialogService,
    private _productManagerService: ProductActionService,
    private _filterProductByChildrenProduct: FilterProductByChildrenProductPipe,
    private _sortProductsByParentProduct: SortProductsByParentProductPipe,
    private _pageLoadingBarService: PageLoadingBarService,
    private _productService: ProductService,
    private _route: ActivatedRoute
  ) {
    this.toggled = new EventEmitter<void>();
    this.InactiveItems = [
      {
        label: TextUtils.getText('text_activate'),
        icon: 'plugins',
        action: () => {
          this.activate();
        },
        className: 'se-product-item-activate-button'
      },
      {
        label: TextUtils.getText('text_delete'),
        icon: 'plugins',
        action: () => {
          this.delete();
        },
        className: 'se-product-item-delete-button'
      }
    ];

    this.UpdateItems = [
      {
        label: TextUtils.getText('text_update'),
        icon: 'plugins',
        action: () => {
          this.update();
        },
        className: 'se-product-item-update-button'
      }
    ];

    this.ActiveItems = [
      {
        label: TextUtils.getText('text_deactivate'),
        icon: 'plugins',
        action: () => {
          this.deactivate();
        },
        className: 'se-product-item-deactivate-button'
      },
      {
        label: TextUtils.getText('text_deactivateDelete'),
        icon: 'plugins',
        action: () => {
          this.showConfirmDeactivateAndDeleteDialog(true);
        },
        className: 'se-product-item-deactivate-and-delete-button'
      }
    ];

  }

  private showConfirmDeactivateAndDeleteDialog(onePlugin = false): void {
    this._dialogService
      .addDialog(ConfirmDialogComponent, {
        header: TextUtils.getText('text_confirmDeactivateAndDeletePlugin.header'),
        message: TextUtils.getText(this.website.parentId ? onePlugin ? 'text_confirmDeactivateAndDeletePlugin.messageNetwork1' : 'text_confirmDeactivateAndDeletePlugin.messageNetwork' : onePlugin ? 'text_confirmDeactivateAndDeletePlugin.message1' : 'text_confirmDeactivateAndDeletePlugin.message'),
        cancelButtonText: TextUtils.getText('text_cancel'),
        confirmButtonText: TextUtils.getText('text_deactivateDelete')
      })
      .subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.delete();
        }
      });
  }

  ngOnInit() {
    this.isManagable = !this.website.isLocalhost && this.userPermissions.canManageContent;
    const queryParams: any = (<any>this._route.queryParams).value;
    if (queryParams && queryParams.show_changelog && queryParams.show_changelog == this.product.productId) {
      this.showChangelog();
    }
    this._userSubscriptions = this._route.snapshot.parent.data['subscriptions'];
    this.currentSubscription = this._route.snapshot.parent.data['subscription'];
    this.isPublishedSinglePlugin = Config.publishedSinglePluginPlans.includes(this.product.slug);
    this._getCompanyInfo();
    this.getParentPlugin();

    this._store.select(fromStore.getLastBuilderTemplate(this.website.id)).subscribe((builderTemplate: BuilderTemplates) => {
      if (builderTemplate && builderTemplate.id) {
        this.lastTemplateItem = builderTemplate;
      }
    });

    this._store.select(fromStore.getWebsiteActiveTheme(this.website.id)).subscribe((theme: Product) => {
      this.activeTheme = theme;
    });

    this._store.select(fromStore.getWebsiteBuilderPlugin(this.website.id)).subscribe((builderProduct: Product) => {
      if (builderProduct) {
        this.builderPlugin = builderProduct ? builderProduct : null;
      }
    });

    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website.id, this.product.slug));
    this.ongoingActivityStatusClass$ = this.ongoingActivity$.pipe(map((activity: IActivity): string => {
      if (!activity) {
        return '';
      }

      if (activity.status === ActivityStatus.DONE) {
        return 'success';
      }
      if (activity.status === ActivityStatus.FAILED) {
        return 'danger';
      }

      return 'info';
    }));
  }

  public getParentPlugin(): void {
    if ( this.product.parentId ) {
      this.parentPlugin = this._filterProductByChildrenProduct.transform(this.allProducts, this.product.parentId)[0];
    }
  }

  public onItemToggled(): void {
    this.toggled.emit();
  }

  public showChangelog(): void {
    if (this.product.tenWebProduct && this.product.paidVersionInstalled) {
      if (!this.product.hasPaidVersionPremium && !this.website.domain_hash) {
        this._router.navigate(['/upgrade-plan']);
      }
      else {
        this._dialogService
          .addDialog(ChangelogComponent, {
            website: this.website,
            product: this.product,
            isManagable: this.isManagable
          })
          .subscribe((isConfirmed: boolean) => {
          });
      }
    }
    else {
      this.update();
    }


  }

  public showPremiumPluginDialog(): void {
    if (this.currentSubscription.type === UserSubscriptionType.FREE && this.isPublishedSinglePlugin) {
      this._dialogService
        .addDialog(PremiumPluginDialogComponent, {
          website: this.website,
          product: this.product,
          isManagable: this.isManagable,
          userSubscriptions: this._userSubscriptions,
          currentSubscription: this.currentSubscription,
          fromExtension: false,
          color: undefined
        });
    }
    else {
      const activeTab = (this.currentSubscription.category === UserSubscriptionCategory.STARTER || this.currentSubscription.category === UserSubscriptionCategory.REGISTERED) ? 'platform' : 'bundle';
      this._router.navigate(['/upgrade-plan'], { queryParams: {plugin_slug: this.product.slug, plugin_title: this.product.title, active_tab: activeTab } });
    }

  }

  public showExtensions(parentId, parentProduct): void {
    this._dialogService
      .addDialog(ExtensionsComponent, {
        website: this.website,
        product: this.product,
        parentProduct: parentProduct,
        parentId: parentId,
        scope: 'pluginExtensions',
        isManagable: this.isManagable,
        userSubscriptions: this._userSubscriptions,
        currentSubscription: this.currentSubscription
      });
  }

  public stopEvent($event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }

  public install(): void {
    let network = 0;
    if (this.product.type !== 'theme' && (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId))) {
      network = 1;
    }
    this.dispatchActions(network, ActivityAction.INSTALL);
  }

  public installAndActivate(): void {
    const network = 0;
    if (this.product.type !== 'theme' && (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId))) {
      this.openConfirmationDialog(network, ActivityAction.INSTALL_ACTIVATE);
    }
    else {
      this.dispatchActions(network, ActivityAction.INSTALL_ACTIVATE);
    }
  }

  public activate(): void {
    const network = 0;
    const hasLastImportedTemplate: boolean = this.lastTemplateItem && this.lastTemplateItem.id ? true : false;
    if (this.product.type === 'theme' && hasLastImportedTemplate && this.activeTheme && this.activeTheme.slug === Config.tenWebThemeSlug && this.product.slug !== Config.tenWebThemeSlug) {
      this._dialogService
        .addDialog(ThirdPartyThemeActivationDialogComponent)
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.dispatchActions(network, ActivityAction.DEACTIVATE, this.builderPlugin);
            this.dispatchActions(network, ActivityAction.ACTIVATE);
          }
        });
    }
    else {
      if (this.product.type !== 'theme' && this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
        this.openConfirmationDialog(network, ActivityAction.ACTIVATE);
      }
      else {
        this.dispatchActions(network, ActivityAction.ACTIVATE);
      }


    }
  }

  public deactivate(): void {
    const network = 0;
    if (this.product.type !== 'theme' && (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId))) {
      this.openConfirmationDialog(network, ActivityAction.DEACTIVATE);
    }
    else {
      this.dispatchActions(network, ActivityAction.DEACTIVATE);
    }

  }

  public update(): void {
    this.dispatchActions(0, ActivityAction.UPDATE);
  }

  public delete(): void {
    this.dispatchActions(0, ActivityAction.DEACTIVATE_DELETE);
  }

  public upgrade(): void {
    this.dispatchActions(0, ActivityAction.UPDATE);
  }

  public installPaidVersion(): void {
    this.installAndActivate();
  }

  private dispatchActions(network, action, product = this.product) {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [product],
      action: action,
      network: network
    }));
  }

  private openConfirmationDialog(network, action) {
    this._dialogService
      .addDialog(MultisiteActionConfirmDialogComponent, {
        header: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.header' : 'text_multisiteActivate.header'),
        message: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.message' : 'text_multisiteActivate.message'),
        singleSiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_deactivate' : 'text_activate'),
        multisiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_networkDeactivate' : 'text_networkActivate'),
        product: this.product
      })
      .subscribe((confirmed: string|boolean) => {
        if (confirmed) {
          if (confirmed === 'network') {
            network = 1;
          }
          this.dispatchActions(network, action);
        }
      });
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        first()
      )
      .subscribe((companyInfo: any) => {
        this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
        // Update productDesc with replaced company name
        if (this.product.description.length > 120) {
          const shortDesc = this.product.description.replace(/10Web/gi, this.companyName).substr(0, 120);
          this.productDesc = shortDesc.substr(0, Math.min(shortDesc.length, shortDesc.lastIndexOf(" "))) + '...';
        }
        else {
          this.productDesc = this.product.description.replace(/10Web/gi, this.companyName);
        }
      });
  }

  public get displayAuthor(): string {
    if (!this.product || !this.product.author) {
      return '';
    }
    return this.product.author.replace(/10Web/gi, this.companyName);
  }

  public get displayTitle(): string {
    if (!this.product || !this.product.title) {
      return '';
    }
    return this.product.title.replace(/10Web/gi, this.companyName);
  }

  public get displayDescription(): string {
    if (!this.product || !this.product.description) {
      return '';
    }
    return this.product.description.replace(/10Web/gi, this.companyName);
  }

}

